import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import SearchWord from './SearchWord';
import Null from './Null';
import LinkIlona from './LinkIlona';




function App() {
  return (
    <div className='App'>
      
    
      <SearchWord/>
      
<LinkIlona/>
    
    <Null/>
   
    </div>
  );
}

export default App;
